import { Sparkles } from "lucide-react";
import AiAssistantSection from "@/pages/client-tabs/AiAssistantSection";
import { NARWHAL_CLIENT_ID } from "@/lib/api";

export default function AiAssistantPage() {
  return (
    <div className="space-y-6" data-testid="ai-assistant-page">
      <div className="flex items-start gap-4 pb-2 border-b border-slate-200">
        <div className="h-12 w-12 rounded-md bg-gradient-to-br from-indigo-600 to-purple-600 text-white flex items-center justify-center shrink-0">
          <Sparkles className="h-6 w-6" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[11px] uppercase tracking-[0.2em] text-indigo-700 font-semibold">Asistente IA</div>
          <h1 className="font-display text-2xl font-semibold text-slate-900 tracking-tight">Análisis de conversaciones outbound</h1>
          <p className="text-xs text-slate-500 mt-1 max-w-2xl">
            Pedile a Claude que analice tus conversaciones de Outreach (Narwhal). Detectá oportunidades calientes, respuestas tardías e intención de compra no aprovechada.
          </p>
        </div>
      </div>

      <AiAssistantSection clientId={NARWHAL_CLIENT_ID} />
    </div>
  );
}
